import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

export const LISTING_COLUMNS = [
  {
    id: 'label',
    label: 'Language',
    align: 'left',
    width: '10%',
    dataKey: 'label',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'fileName',
    label: 'File Name',
    align: 'left',
    width: '20%',
    dataKey: 'fileName',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    align: 'center',
    dataKey: 'status',
    sortable: false,
    type: CELL_DATA_TYPES.SWITCH,
  },

  {
    id: 'modifiedAt',
    label: 'Uploaded Date',
    align: 'left',
    dataKey: 'modifiedAt',
    sortable: false,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
  {
    action: ACTIONS.DOWNLOAD.value,
    label: ACTIONS.DOWNLOAD.label,
    icon: 'ic:round-download',
  },
];
